import { createApp } from 'vue';
import App from './App.vue';

export function createUpsellsApp() {
  const app = createApp(App);

  app.mount('#upsells-app');
}
